import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfirmationModel } from '@app-shared/models/alert-confimation.model';
import { CreateNewMasterModel } from '@app-shared/models/create-new-master.model';
import { AlertToastService } from '@app-shared/services/alert-toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-create-new-master',
  templateUrl: './create-new-master.component.html',
  styleUrls: ['./create-new-master.component.scss']
})
export class CreateNewMasterComponent implements OnInit {

  @Output() closedModal = new EventEmitter<ConfirmationModel>();
  @Output() saveModal = new EventEmitter<string>();

  // Modal Params
  public createMasterPreview;
  public createMasterErrorMessage = '';

  public isPreviewBlocked = false;
  public newMasterId = null;
  public reviewNotes = '';
  public createMasterDetail: CreateNewMasterModel;

  constructor() { }

  ngOnInit(): void {
    if (this.createMasterPreview) {
      this.newMasterId = this.createMasterPreview;
    } else {
      this.isPreviewBlocked = true;
    }
  }

  public save(){
    this.saveModal.emit(this.reviewNotes);
  }

  public close(){
    this.closedModal.emit({status: 'ok'});
  }
}
